import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-control-landing-page',
  templateUrl: './project-control-landing-page.component.html',
  styleUrls: ['./project-control-landing-page.component.scss']
})
export class ProjectControlLandingPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
